import React from 'react'
import { convertShortcodesToHTML } from '../../../services/common'
import { Parser } from '../../common'

const Item = ({ block }) => {
    return (
        <>
            {block?.content && (
                <li className="!baseocom-list-disc">{convertShortcodesToHTML(block?.content)}</li>
            )}
            {block?.childrens && <Parser content_block={block?.childrens} />}
        </>
    )
}

export default Item
